var map = {
	"./add_col_after.svg": "adPA",
	"./add_col_before.svg": "qUXR",
	"./add_row_after.svg": "nu13",
	"./add_row_before.svg": "IPMJ",
	"./bold.svg": "60F2",
	"./checklist.svg": "p2tV",
	"./code.svg": "t0xJ",
	"./combine_cells.svg": "L0NL",
	"./delete_col.svg": "mIZu",
	"./delete_row.svg": "sWjD",
	"./delete_table.svg": "eHdu",
	"./github.svg": "9l8z",
	"./hr.svg": "3MpJ",
	"./image.svg": "4dFk",
	"./italic.svg": "ojIv",
	"./link.svg": "AjaZ",
	"./mention.svg": "0/UQ",
	"./ol.svg": "a9CK",
	"./paragraph.svg": "Nyxy",
	"./quote.svg": "P9GJ",
	"./redo.svg": "RJNC",
	"./remove.svg": "dipE",
	"./strike.svg": "yZZt",
	"./table.svg": "dMEh",
	"./ul.svg": "NJ63",
	"./underline.svg": "EW7n",
	"./undo.svg": "Wv8T"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "z8gY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons ^\.\/.*\.svg$
// module id = z8gY
// module chunks = 1